/* eslint-disable jsx-a11y/media-has-caption */
import { Button, Col, Modal, Row } from 'antd'
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { BaseButton } from 'components/elements/BaseButton'
import { useWebSettings } from 'raducer/webSettings'
import { useAppDispatch } from 'hooks'
import { baseAPI } from 'api/baseApi'
import { globalConfirm, globalToaster } from 'components/elements/global'
import { globalConfig } from 'antd/lib/config-provider'
import fabImage from '../images/facebook.png'
import { AddNewIntegrationModal } from './AddFbntegrationModal'
import { TIntegrationFBPages, TIntegrationItem } from '../types'
import { useFbPagesMutation } from '../api'
import { useIntegrationContext } from '../provider/IntegrationContext'

const FbIntergrationModal: FC<{
 show?: boolean
 onCancel?: () => void
 intItems?: TIntegrationItem[]
 setIntItems?: Dispatch<SetStateAction<TIntegrationItem[]>>
}> = ({ onCancel, show, intItems, setIntItems }) => {
 const [showIntegrationModal, setShowIntegrationModal] = useState(false)
 const [fbPageData, setFbPageData] = useState<TIntegrationItem[]>([])

 const [activeBtnLoading, setActiceBtnLoading] = useState(false)
 const { onDisconnectFb } = useIntegrationContext()
 const { FB }: any = window
 const [fbPages] = useFbPagesMutation()
 const { onboarding_settings } = useWebSettings()
 const { onBoardListingStatus } = onboarding_settings || {}
 const d = useAppDispatch()

 useEffect(() => {
  setFbPageData(intItems ?? [])
 }, [intItems])

 return (
  <Modal
   footer={null}
   visible={show}
   onCancel={() => {
    d(baseAPI.util.invalidateTags(['FB-INT_LIST']))
    onCancel?.()
   }}
   width="100%"
  >
   <div className="intgr-modal">
    <div className="intgr-modal-top">
     <div className="intgr-modal-lgo">
      <img className="int-card-new-img" src={fabImage} alt="" />
      <p>
       Easily link your Facebook Lead Ads to AgentRoof CRM and capture leads
       instantly with just a few clicks
      </p>
      {fbPageData.length > 0 && (
       <BaseButton
        buttonType="danger"
        onClick={() => onDisconnectFb?.('', true)}
        shape="round"
       >
        Disconnect
       </BaseButton>
      )}
     </div>
     <div className="intgr-modal-content">
      <Row style={{ flex: 1 }} align="middle">
       <Col flex={1}>
        {fbPageData.length > 0 ? (
         <FbPageDataBlock
          setFbPageData={setFbPageData}
          handleAddMorePage={() => setShowIntegrationModal(true)}
          handleDisconnectAll={() => {
           onDisconnectFb?.('', true)
           //  onCancel?.()
          }}
          data={fbPageData}
         />
        ) : (
         <FbPageConnectBlock onConnect={() => setShowIntegrationModal(true)} />
        )}
        {/* <FbPageDataBlock /> */}
       </Col>
       <div className="intgr-modal-video">
        <video controls>
         <source
          src="https://cdn.agentroof.com/crm-tutorial/facebook-integration.mp4"
          type="video/mp4"
         />
         Your browser does not support the video tag.
        </video>
       </div>
      </Row>
     </div>
    </div>
    <hr className="mt-4" style={{ border: '2px solid #aaa', width: '100%' }} />
    <div className="intgr-modal-bottom">
     <p>
      Supercharge your lead management process by integrating your CRM with
      Facebook Lead Ads. With this powerful integration, you can effortlessly
      capture leads and drive more personalized interactions to maximize your
      conversions.
     </p>
     <h4>Key Features:</h4>
     <ul>
      <li>
       <strong>Automatic Lead Import:</strong> All leads generated from your
       Facebook campaigns are instantly synced with your CRM, eliminating manual
       data entry.
      </li>
      <li>
       <strong>Source Assignment by Campaign Name:</strong> Leads created from
       Facebook campaigns are automatically assigned a source based on the
       campaign name, enabling better organization and segmentation.
      </li>
      <li>
       <strong>Actionable Insights:</strong> Use the campaign name as a source
       to trigger automated workflows, such as Action Plans, Listing Alerts, and
       other tasks, ensuring timely and effective engagement with your leads.
      </li>
      <li>
       <strong>Streamlined Lead Nurturing:</strong> Track and manage Facebook
       leads alongside your other CRM leads, making it easy to design
       personalized follow-ups and maintain consistent communication
      </li>
      <li>
       <strong>Enhanced Productivity:</strong> Automate repetitive tasks for
       Facebook leads, saving you time and letting you focus on converting
       prospects into clients.
      </li>
      <li>
       <strong>Increased ROI:</strong> Leverage lead data from Facebook
       campaigns to tailor your marketing strategies and optimize conversions.
      </li>
     </ul>
     <h4>Why Use Facebook Lead Provider Integration? </h4>
     <p>
      This integration helps you stay organized and proactive, ensuring you
      respond quickly to potential clients and keep your pipeline full. By
      aligning leads with specific campaigns, you gain better visibility into
      your lead sources, making it easier to prioritize and act on high-value
      opportunities. Integrating Facebook Lead Ads with your CRM is the perfect
      way to maximize the value of your ad spend and turn social media
      engagements into actionable business outcomes.
     </p>
    </div>
   </div>
   {showIntegrationModal && (
    <AddNewIntegrationModal
     show={showIntegrationModal}
     intItems={fbPageData}
     setIntItems={setFbPageData}
     OnCancel={() => {
      setShowIntegrationModal(false)
     }}
    />
   )}
  </Modal>
 )
}

export default FbIntergrationModal

const FbPageDataBlock: FC<{
 setFbPageData?: React.Dispatch<React.SetStateAction<TIntegrationItem[]>>
 handleAddMorePage?: () => void
 handleDisconnectAll?: () => void
 data: TIntegrationItem[]
}> = ({ data, handleDisconnectAll, handleAddMorePage, setFbPageData }) => {
 const { onDisconnectFb } = useIntegrationContext()
 return (
  <div className="p-4">
   <h2>Facebook Lead Ads Connected Pages</h2>
   <div
    style={{
     display: 'flex',
     maxHeight: '300px',
     overflowY: 'auto',
     flexDirection: 'column',
     rowGap: '6px',
     alignItems: 'start',
    }}
   >
    {data.map((item, index) => (
     <FbPageDataBlockItem
      setFbPageData={setFbPageData}
      OnDisconnect={(v) => {
       onDisconnectFb?.(v?.page_id)
      }}
      item={item}
      key={index}
     />
    ))}
   </div>
   <div className="d-flex mt-3" style={{ columnGap: '5px' }}>
    <BaseButton
     buttonType="primary"
     onClick={handleAddMorePage}
     shape="round"
     //  type="primary"
    >
     <span className="fas fa-plus me-2" /> Add More Pages
    </BaseButton>
    {/* <Button onClick={handleDisconnectAll} shape="round">
     Disconnect All Pages
    </Button> */}
   </div>
  </div>
 )
}
const FbPageDataBlockItem: FC<{
 setFbPageData?: React.Dispatch<React.SetStateAction<TIntegrationItem[]>>
 OnDisconnect?: (v?: TIntegrationItem) => void
 item: TIntegrationItem
}> = ({ item, OnDisconnect, setFbPageData }) => {
 //  const { setFbIntegrationData } = useIntegrationContext()
 const [activeBtnLoading, setActiceBtnLoading] = useState(false)
 const { FB }: any = window
 const [fbPages] = useFbPagesMutation()
 const { onboarding_settings } = useWebSettings()
 const { onBoardListingStatus } = onboarding_settings || {}
 const d = useAppDispatch()

 const handleActiveFbPage = async (itm: TIntegrationFBPages) => {
  setActiceBtnLoading(true)
  const val: TIntegrationFBPages = {
   import_lead: itm.import_lead,
   page_access_token: itm?.page_access_token,
   page_id: `${itm?.page_id}`,
   page_name: itm?.page_name,
   fb_access_token: FB?.getAccessToken(),
  }
  await FB.api(
   `/${val?.page_id}/subscribed_apps`,
   'post',
   {
    subscribed_fields: 'leadgen',
    access_token: val?.page_access_token,
   },
   (res: any) => {
    if (res?.success) {
     fbPages?.(val)
      ?.unwrap()
      ?.then(() => {
       if (!onBoardListingStatus?.facebook_integration) {
        d(baseAPI.util.invalidateTags(['WEB-SETTINGS']))
       }
       setActiceBtnLoading(false)
       setFbPageData?.((prv) =>
        prv.map((itms) =>
         itms?.page_id === val?.page_id ? { ...itms, status: 'Active' } : itms,
        ),
       )
       //  d(baseAPI.util.invalidateTags(['FB-INT_LIST']))
       return Promise.resolve()
      })
      .catch(() => {
       setActiceBtnLoading(false)
       return Promise.reject()
      })
    } else if (res?.error) {
     globalToaster({ type: 'error', content: 'Something went wrong' })
     setActiceBtnLoading(false)
     return Promise.reject()
    } else {
     return Promise.reject()
    }
   },
  )
 }

 return (
  <div
   className="px-2 py-1"
   style={{
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #bbb',
    borderRadius: '7px',
    width: '480px',
    maxWidth: '100%',
   }}
  >
   <span>
    {item.page_name}{' '}
    {item.status === 'Active' && (
     <i className="fas fa-check-circle text-success" />
    )}{' '}
   </span>
   <BaseButton
    loading={item.status === 'Activate' && activeBtnLoading}
    onClick={() => {
     if (item.status === 'Activate') {
      handleActiveFbPage?.(item)
     } else if (item.status === 'Active') {
      OnDisconnect?.(item)
     }
    }}
    style={{
     padding: '1px 12px',
     height: 'auto',
     fontSize: '12px',
     borderRadius: '4px',
    }}
    type={item.status === 'Activate' ? 'link' : 'link'}
    // buttonStyle="outline"
    // buttonType="danger"
    size="small"
    // icon={}
   >
    {item.status === 'Activate' ? (
     'Activate'
    ) : (
     <i style={{ fontSize: '17px' }} className="fas fa-times-circle" />
    )}
   </BaseButton>
  </div>
 )
}

const FbPageConnectBlock: FC<{
 onConnect?: () => void
}> = ({ onConnect }) => {
 return (
  <div className="p-4">
   <h2>Configure Facebook Lead Ads</h2>
   <ol className="ps-4">
    <li>Click the Connect Facebook button to connect your Facebook account</li>
    <li>Select the Facebook pages you want to connect to AgentRoof</li>
    <li>Click Continue</li>
   </ol>
   <Button onClick={onConnect} shape="round" type="primary">
    Connect Facebook
   </Button>
  </div>
 )
}
